import { observable, action } from 'mobx'
import { firebase } from '../constants'
import { resultStore } from './../stores'

class AuthStore {
  @observable error = null
  @observable authenticating = true
  @observable auth = false
  @observable sent = null

  @action.bound signUp (email, password) {
    return firebase.auth()
      .createUserWithEmailAndPassword(email, password)
      .then(action(user => { this.auth = user; this.error = null; return user; }))
      .catch(action(x => this.error = x.message))
  }

  @action.bound signIn (email, password) {
    return firebase.auth()
      .signInWithEmailAndPassword(email, password)
      .catch(action(x => this.error = x.message))
  }

  @action.bound signOut () {
    return firebase.auth().signOut()
  }

  @action.bound resetPassword (email) {
    return firebase.auth()
      .sendPasswordResetEmail(email)
      .then(action(() => {
        this.sent = true
      }))
      .catch(action(error => {
        this.error = error
      }))
  }

  @action.bound listenToAuth () {
    this.authenticating = true
    return firebase.auth()
      .onAuthStateChanged(action(user => {
        this.authenticating = false
        if (user) {
          // signed in
          this.auth = user
          resultStore.loadChurchResponse()
        } else {
          // signed out
          this.auth = null
          resultStore.resetChurch()
        }
      }))
  }

  @action.bound reset () {
    this.error = null
    this.sent = null
  }

}

export default new AuthStore()



// WEBPACK FOOTER //
// ./src/auth/auth-store.js